import { CheckboxStyled } from 'src/common/components/CheckboxStyled/CheckboxStyled';
import { useExternalRowSelectionApi } from './hooks/useExternalRowSelectionApi';
import { gridDataRowIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { TableCellContent, TableCellDataBox } from '../../Header/HeaderCell';

export const ExternalRowSelectionAllCheckbox = () => {
  const { selectedIds, toggleAll } = useExternalRowSelectionApi();
  const apiRef = useGridApiContext();

  const dataRowIds = useGridSelector(apiRef, gridDataRowIdsSelector);
  const allSelected = dataRowIds.length > 0 && dataRowIds.every((id) => selectedIds.has(id));

  return (
    <TableCellContent>
      <TableCellDataBox sortable={false} align={'center'}>
        <CheckboxStyled
          isChecked={allSelected}
          onChange={() => {
            toggleAll(dataRowIds);
          }}
          slotProps={{
            input: {
              'aria-label': 'Select all rows',
            },
          }}
        />
      </TableCellDataBox>
    </TableCellContent>
  );
};
